export { default as notificationService } from './notification.service';
